(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientBarcodeDetailController', PatientBarcodeDetailController);

    PatientBarcodeDetailController.$inject = ['patientResult', 'barcode', 'moment', '$compile', '$scope', 'GUIUtils',
        '$q', '$uibModal', 'PatientOrderTest', 'DTOptionsBuilder', 'DTColumnBuilder',
        'patient'];

    function PatientBarcodeDetailController(patientResult, barcode, moment, $compile, $scope, GUIUtils,
                                            $q, $uibModal, PatientOrderTest, DTOptionsBuilder, DTColumnBuilder,
                                            patient) {
        var vm = this;

        vm.barcode = barcode;
        vm.patient = patient;
        vm.patientResult = patientResult;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            PatientOrderTest.findAllByBarcode({barcode: vm.barcode.id}, function (result) {
                vm.patientOrderTests = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order').renderWith(function (data, type, full) {
                return showOrder(data);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diagnosis (ICD10)').renderWith(function (data, type, full, meta) {
                return data.diagnoses != null && data.diagnoses.length > 1 ? data.diagnoses[0].icd10Code + showICD10Html(meta.row) : data.diagnoses[0].icd10Code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.renal);//colorHtml(data.renal);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            })
        ];

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        }

        vm.showICD10 = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrderTests[index]
                }
            });
        }

        function showOrder(row) {
            return '<a ui-sref="' + "patient-order-view({id:" + vm.patient.id + ", oid:" + row.patientOrderId + "})" + '">' + row.patientOrderId + '</a>';
        }
    }
})();
